// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./NoPreviewPageStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import { PageWrapper } from "../../index";
// Icon
import NoPreview from "../../../icons/NoPreview/NoPreview";
import Alert from "../../../icons/Alert/Alert";
export const NoPreviewPage = (props) => {
    const classes = useStyles(props);
    const { type, previewWidth, previewHeight } = props;
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "center", style: { width: previewWidth, height: previewHeight }, className: classes.noPreviewWrapper },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" }, type === "noPreview" ?
                        React.createElement(NoPreview, { className: classes.noPreviewIcon })
                        : React.createElement(Alert, { className: classes.noPreviewIcon })),
                    React.createElement(Grid, { item: true, md: 12, container: true, justifyContent: "center", alignItems: "center" },
                        React.createElement("span", { className: classes.noPreviewContent }, type === "noPreview" ?
                            "No Preview Available" : "Please select at least one of the option")))))));
};
NoPreviewPage.defaultProps = {
    type: "noPreview",
};
export default React.memo(NoPreviewPage);
